import experimentMixin from "@/mixins/experiment-mixin.js";
import { experimentSettings } from "@/constants/experiments";
import { routeData } from "@/router/constants/routes";

export async function scheduleBeforeEnter(to, from) {
    const isSchedulingEnabled = experimentMixin.methods.hasSettingEqualTo(
        experimentSettings.USE_SCHEDULING_PAGE,
        "true"
    );
    if (isSchedulingEnabled) {
        // Do not use replace: true — /schedule is never committed, so replace would drop quote from history.
        return {
            name: routeData.SCHEDULING.name,
        };
    }
}
